export type ReportReactionNumeric = -1 | 1 | undefined;

export enum ReportReactionEnum {
  Like = "like",
  Dislike = "dislike",
}

export type ReportReaction =
  ReportReactionEnum.Like | ReportReactionEnum.Dislike | undefined;

export const ratingMap = new Map();
ratingMap.set(-1, "dislike");
ratingMap.set(1, "like");
ratingMap.set("dislike", -1);
ratingMap.set("like", 1);
